import { memo, useCallback } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { useSelector } from '@bonanza-social/toolkit/state';
import { useNavigation, StackNavigationProp } from '@bonanza-social/navigation';
import { LobbyWidget } from '@bonanza-social/moonlight';
import {
  selectCommunityJackpotRewards,
  selectIsCommunityJackpotVisible,
} from '../../state';

function CommunityJackpotWidget() {
  const { t } = useTranslation('communityJackpot');
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const playerRewards = useSelector(selectCommunityJackpotRewards);
  const isVisible = useSelector(selectIsCommunityJackpotVisible);

  const onClick = useCallback(() => {
    navigation.navigate('CommunityJackpot');
  }, [navigation]);

  return isVisible ? (
    <LobbyWidget
      image="communityJackpot.communityJackpot"
      label={t('widgetLabel')}
      hasUnread={playerRewards.length > 0}
      onClick={onClick}
    />
  ) : null;
}

export default memo(CommunityJackpotWidget);
